import { defineCollection } from "@rebasepro/cms-types";
import { personName, playerOf } from "../people";

// A browser that said yes to notifications (Web Push): where its push service takes messages for it, and the keys that
// lock them so only that browser reads them. One row per browser, kept by account. backend/src/invites.ts writes it when
// a phone turns notifications on, and deletes a row once its push service says the browser is gone.
const pushSubscriptionsCollection = defineCollection({
    name: "Push subscriptions",
    singularName: "Push subscription",
    slug: "push_subscriptions",
    table: "songbuzz_push",
    description: "Browsers that turned notifications on, for friends asking them to a game.",
    securityRules: [
        { operation: "select", roles: ["admin"] },
        { operation: "delete", roles: ["admin"] },
    ],
    properties: {
        // the endpoint's hash: endpoints run to hundreds of characters
        id: { name: "Id", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        who: { name: "Account", type: "string", validation: { required: true }, admin: { readOnly: true, hideFromCollection: true } },
        player: playerOf("Player", "who", "player"),
        endpoint: { name: "Endpoint", type: "string", validation: { required: true }, admin: { readOnly: true, hideFromCollection: true } },
        p256dh: { name: "Key", type: "string", validation: { required: true }, admin: { readOnly: true, hideFromCollection: true } },
        auth: { name: "Secret", type: "string", validation: { required: true }, admin: { readOnly: true, hideFromCollection: true } },
        lang: { name: "Notifications in", type: "string", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "language" } } },
        at: { name: "Turned on", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
        lastSent: { name: "Last sent", type: "date", admin: { readOnly: true } },
    },
    indexes: [
        { on: ["who"], reason: "an account's browsers, each time a friend asks them to a game" },
    ],
    admin: {
        icon: "BellRing",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["at", "desc"],
        display: {
            title: async ({ entity, context }) => personName(context, entity.values.who),
            // the browser's push service says which browser it is
            subtitle: ({ entity }) => {
                let host = "";
                try { host = new URL(String(entity.values.endpoint)).host; } catch { return undefined; }
                if (/apple/.test(host)) return "Safari (iPhone, iPad or Mac)";
                if (/google|fcm/.test(host)) return "Chrome or Android";
                if (/mozilla/.test(host)) return "Firefox";
                if (/windows|notify/.test(host)) return "Edge";
                return host;
            },
            date: "at",
        },
        listProperties: ["lang", "at", "lastSent"],
        form: {
            sections: [
                { key: "push", properties: ["player", "lang", "at", "lastSent"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["id", "who", "endpoint", "p256dh", "auth"] },
            ],
        },
    },
});

export default pushSubscriptionsCollection;
